





































import Vue from "vue";
import { Prop } from "vue-property-decorator";
import { Device } from "../../../types/core";
import Component from "vue-class-component";
import DownlinksQueueSection from "@/components/device/DownlinksQueueSection.vue";
import { curDeviceService } from "@/services/DeviceService";
import { DeviceCommandReq } from "@/services/CoreClient";
import _ from "lodash";

@Component({
  components: {
    DownlinksQueueSection,
  },
})
export default class LinkBoxControl extends Vue {
  @Prop({ default: () => { }, type: Object }) device!: Device;
  @Prop({ default: () => { }, type: Object }) bus!: Vue;

  private httpBusy: boolean = false;

  private error: string = '';


  created() { }
  async mounted() { }

  async overLoadEventTest() {
    try {
      await curDeviceService.sendDeviceCommand({
        deviceId: this.device.deviceId,
        command: 'overload_event_test',
        updateConfiguration: true,
      } as DeviceCommandReq);
      this.bus.$emit('refresh');

      setTimeout(() => { this.bus.$emit('close'); }, 2000);
    } catch (err) {
      this.error = (err as Error).message;
    }
  }

  async overTempEventTest() {
    try {
      await curDeviceService.sendDeviceCommand({
        deviceId: this.device.deviceId,
        command: 'overtemp_event_test',
        updateConfiguration: true,
      } as DeviceCommandReq);
      this.bus.$emit('refresh');

      setTimeout(() => { this.bus.$emit('close'); }, 2000);
    } catch (err) {
      this.error = (err as Error).message;
    }
  }

  async productionMode() {
    try {
      await curDeviceService.sendDeviceCommand({
        deviceId: this.device.deviceId,
        command: 'production_mode',
        updateConfiguration: true,
      } as DeviceCommandReq);
      this.bus.$emit('refresh');

      setTimeout(() => { this.bus.$emit('close'); }, 2000);
    } catch (err) {
      this.error = (err as Error).message;
    }
  }


  cancel() {
    this.$emit('close');
  }
}
